import CreateAnalysisRequest from "api/lib/data/interfaces/api/CreateAnalysisRequest";
import Organizations from "api/lib/data/Organizations";
import * as Joi from "joi";
import * as React from "react";
import { toast } from "react-semantic-toasts";
import { Form as UIForm, Message, Modal, Button } from "semantic-ui-react";
import { Event } from "src/components/Common/Base";
import {
  Form,
  IInterfaceFormProps,
  IInterfaceFormState,
} from "src/components/Form";

interface IInterfaceProps extends IInterfaceFormProps {
  authUser: any;
  orgId: string;
  trigger: React.ReactNode;
}

interface IInterfaceState extends IInterfaceFormState {
  error: any;
  open: boolean;
}

export class DashboardForm extends Form<IInterfaceProps, IInterfaceState> {
  private static INITIAL_STATE = {
    open: false,
    data: {
      name: "",
    },
    error: null,
    errors: {},
  };

  private static schema: Joi.SchemaLike = {
    name: Joi.string().required().label("Name"),
  };
  private static propKey(propertyName: string, value: any): object {
    return { [propertyName]: value };
  }

  constructor(props: IInterfaceProps) {
    super(props, DashboardForm.schema);
    this.state = { ...Form.FORM_INITAL_STATE, ...DashboardForm.INITIAL_STATE };
  }

  private setOpen = (open: boolean) => {
    this.setState({ open });
  };

  public render() {
    const { error, open } = this.state;

    return (
      <Modal
        size="small"
        onClose={() => this.setOpen(false)}
        onOpen={() => this.setOpen(true)}
        open={open}
        trigger={this.props.trigger}
      >
        <Modal.Header>New Dashboard</Modal.Header>

        <Modal.Content>
          <UIForm onSubmit={this.handleSubmit} size="small">
            {this.renderInput("name", "Name", false)}
            {error && <Message error={true} header={error.message} />}
          </UIForm>
        </Modal.Content>
        <Modal.Actions>
          <Button color="black" onClick={() => this.setOpen(false)}>
            Cancel
          </Button>
          {this.renderSubmitButton("Create")}
        </Modal.Actions>
      </Modal>
    );
  }
  protected doSubmit(callback: () => void) {
    const { data } = this.state;
    const { authUser, orgId } = this.props;
    const { name } = data;
    const org = new Organizations();

    const analysisReq: CreateAnalysisRequest = {
      name,
      audit: {
        createdBy: authUser.uid,
      },
    };
    org
      .createDashboard(orgId, authUser.uid, analysisReq)
      .then((requestRef: firebase.database.Reference) => {
        this.getListner(
          org.getApiResponse(orgId, authUser.uid, requestRef.key),
          Event.Value,
          (snapshot: firebase.database.DataSnapshot) => {
            const resp = snapshot.val();
            if (resp && resp.headers) {
              if (resp.headers.statusCode === 200) {
                this.setState(() => ({ ...DashboardForm.INITIAL_STATE }));
                toast({
                  type: "success",
                  icon: "info circle",
                  title: `Dashboard created successfully `,
                  animation: "slide up",
                  time: 5000,
                });
                callback();
              } else {
                const error = { message: resp.headers.msg };
                this.setState(DashboardForm.propKey("error", error));
                callback();
              }
            }
          }
        );
      })
      .catch((error) => {
        callback();
        this.setState(DashboardForm.propKey("error", error));
      });
  }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboards/DashboardForm.tsx